import { useTranslation } from "react-i18next";
import { useState } from "react";
import { useBasicComponents } from "./useBasicComponent";
import { AIOpsVariablesEditableTable } from "@/components/instance/config/AIOpsVariablesEditableTable";

export const useDruidConfig = (action = "create", defaultValues = {}) => {
  const { t } = useTranslation();
  const initVal = defaultValues.enableDruid != null ? defaultValues.enableDruid : true;
  const [enableDruid, setEnableDruid] = useState(initVal);
  const {
    replicas,
    replicasReadOnly,
    core,
    memory,
    dataDisk,
    javaOpts,
  } = useBasicComponents(action, defaultValues);

  const zookeeperColumns = () => {
    const group = "druid-zookeeper";
    return [
      replicas({ group }),
      core({ group }),
      memory({ group }),
      dataDisk({ group }),
      javaOpts(group),
    ];
  };

  const coordinatorColumns = () => {
    const group = "coordinator";
    return [
      replicas({ group }),
      core({ group }),
      memory({ group }),
      dataDisk({ group }),
      javaOpts(group),
    ];
  };

  const brokerColumns = () => {
    const group = "broker";
    return [
      replicas({ group }),
      core({ group }),
      memory({ group }),
      dataDisk({ group }),
      javaOpts(group),
    ];
  };

  const routerColumns = () => {
    const group = "router";
    return [
      replicas({ group }),
      core({ group }),
      memory({ group }),
      dataDisk({ group }),
      javaOpts(group),
    ];
  };

  const middleManagerColumns = () => {
    const group = "middleManager";
    return [
      replicas({ group }),
      core({ group }),
      memory({ group }),
      dataDisk({ group }),
      javaOpts(group),
    ];
  };
  
  const historicalColumns = () => {
    const group = "historical";
    return [
      replicas({ group }),
      core({ group }),
      memory({ group }),
      dataDisk({ group }),
      javaOpts(group),
    ];
  };

  const allInOneColumns = () => {
    const group = "druid-all";
    return [
      replicas({ group }),
      core({ group }),
      memory({ group }),
      dataDisk({ group })
    ];
  };

  const variablesColumns = () => {
    return [
      {
        dataIndex: "env.variables",
        renderFormItem: (item, _, form) => {
          return (
            <AIOpsVariablesEditableTable
              variablesValue={item.initialValue}
              onChange={(newVariables) => {
                const items = newVariables.reduce((acc, item) => {
                  if (item.overrideValue != "") {
                    acc.push({ name: item.name, value: item.overrideValue });
                  }
                  return acc;
                }, []);
                form.setFieldsValue({
                  [item.dataIndex]: items,
                });
              }}
              initData={[
                // {
                //   key: "1",
                //   name: "druid_historical_processing_buffer_sizeBytes",
                //   overrideValue: "",
                // },
                // {
                //   key: "2",
                //   name: "druid_historical_processing_numMergeBuffers",
                //   overrideValue: "",
                // },
                // {
                //   key: "3",
                //   name: "druid_historical_processing_numThreads",
                //   overrideValue: "",
                // },
                // {
                //   key: "4",
                //   name: "druid_worker_capacity",
                //   overrideValue: "",
                // },
              ]}
            />
          );
        },
        formItemProps: {
          rules: [
            ({ getFieldValue }) => ({
              validator(_, value) {
                return Promise.resolve();
                // TODO: validation
                // if (!value || getFieldValue("password") === value) {
                //   return Promise.resolve();
                // }
                // return Promise.reject(
                //   new Error(
                //     t(
                //       "pages.login.errors.notmatch",
                //       "The two passwords do not match!",
                //     ),
                //   ),
                // );
              },
            }),
          ],
        },
        width: "m",
      },
    ];
  };

  const druidSchema = [
    {
      title: t("config.instance.form.zookeeper", "Zookeeper"),
      valueType: "group",
      columns: zookeeperColumns()
    },
    {
      title: t("config.instance.form.coordinator", "Coordinator"),
      valueType: "group",
      columns: coordinatorColumns(),
    },
    {
      title: t("config.instance.form.borkerNode", "Broker"),
      valueType: "group",
      columns: brokerColumns(),
    },
    {
      title: t("config.instance.form.router", "Router"),
      valueType: "group",
      columns: routerColumns(),
    },
    {
      title: t("config.instance.form.middleManager", "Middle Manager"),
      valueType: "group",
      columns: middleManagerColumns(),
    },
    {
      title: t("config.instance.form.historical", "Historical"),
      valueType: "group",
      columns: historicalColumns(),
    },
    {
      title: t("config.instance.form.allInOne", "All In One"),
      valueType: "group",
      columns: allInOneColumns(),
    },
    {
      title: t("config.instance.form.druid", "AIOps"),
      valueType: "group",
      columns: variablesColumns(),
    },
  ];

  // if("update" === action) {
  //   druidSchema.forEach((item) => {
  //     item.hideInForm = !enableDruid;
  //   });
  //   druidSchema.splice(0, 0, {
  //     title: "Enable Druid",
  //     dataIndex: "enableDruid",
  //     valueType: "switch",
  //     initialValue: enableDruid,
  //     fieldProps: {
  //       onChange: (checked) => setEnableDruid(checked),
  //     },
  //   })
  // }

  return druidSchema;
};
